import styled from "styled-components";

export const InputWrapper = styled.div`
	display: flex;
	align-items: end;
`;
